import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import "./BoardsDetailKeyFeatures.css";

import arrowLeft from "../../../../../assets/icons/left.svg";
import arrowRight from "../../../../../assets/icons/right.svg";

const BoardsDetailKeyFeatures = ({ features }) => {
  const { i18n } = useTranslation();
  const trackRef = useRef(null);
  const isRtl = i18n.dir(i18n.language) === "rtl";

  const scrollByStep = (direction) => {
    const el = trackRef.current;
    if (!el) return;
    const first = el.querySelector(".boardsDetailKF-card");
    const step = first ? first.offsetWidth + 1 : 280;
    const normalizedDirection = isRtl ? direction * -1 : direction;
    el.scrollBy({ left: normalizedDirection * step * 2, behavior: "smooth" });
  };

  if (!features?.length) return null;

  return (
    <section className="boardsDetailKF" aria-labelledby="boardsDetailKF-heading">
      <div className="boardsDetailKF-inner">
        <h2 id="boardsDetailKF-heading" className="boardsDetailKF-title">
          Key features
        </h2>

        <div className="boardsDetailKF-scroll" ref={trackRef}>
          {features.map((text, index) => (
            <div className="boardsDetailKF-card" key={`${index}-${text.slice(0, 12)}`}>
              <span className="boardsDetailKF-index">
                {String(index + 1).padStart(2, "0")}
              </span>
              <p className="boardsDetailKF-text">{text}</p>
            </div>
          ))}
        </div>

        <div className="boardsDetailKF-controls">
          <button
            type="button"
            className="boardsDetailKF-arrowBtn"
            onClick={() => scrollByStep(-1)}
            aria-label="Scroll features left"
          >
            <img src={isRtl ? arrowRight : arrowLeft} alt="" />
          </button>
          <button
            type="button"
            className="boardsDetailKF-arrowBtn"
            onClick={() => scrollByStep(1)}
            aria-label="Scroll features right"
          >
            <img src={isRtl ? arrowLeft : arrowRight} alt="" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default BoardsDetailKeyFeatures;
